// :cow: Cosmose CONFIDENTIAL :iso:
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'e-page-404',
  templateUrl: 'page-404.component.html',
  imports: [TranslateModule],
})
export class Page404Component {
}
